import { createSlice } from "@reduxjs/toolkit";
import { ApiState } from "@baseTypes/baseType";
import { GroupedProcess, IWorkDetailRequestBody } from "@baseTypes/service/dashboard/IWorksDashboardService";
import { applyExtraReducer } from "../../../weather";
import { createThunk } from "../../crops/selector";
import { dashboardURL } from "@utils/utils";
import { Methods } from "@api/dashboards";

export interface WorksByDepartmentsAndCropsState extends ApiState {
    data: GroupedProcess
}

const initialState: WorksByDepartmentsAndCropsState = {
    apiError: '',
    isApiLoading: false,
    data: {
        total: {
            plan: 0,
            fact: 0
        },
        progressByCrop: undefined,
        progressByDepartment: undefined,
        displayName: ''
    }
}

const fetchWorksByDepartmentsAndCrops = createThunk<GroupedProcess, IWorkDetailRequestBody, IWorkDetailRequestBody>()(
    { url: dashboardURL('groupedProgress'), method: Methods.POST },
    (payload, url) => ({
        url,
        data: payload
    })
)

const worksByDepartmentsAndCropsSlice = createSlice({
    name: 'worksByDepartmentsAndCropsSlice',
    initialState,
    reducers: {},
    extraReducers: builder => {
        applyExtraReducer(builder, fetchWorksByDepartmentsAndCrops, {
            fulfillReducer: (state, action) => {
                state.data = action.payload
            }
        })
    }
})

export const actions = { ...worksByDepartmentsAndCropsSlice.actions, fetchWorksByDepartmentsAndCrops }

export default worksByDepartmentsAndCropsSlice.reducer